import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/production/final_packing_list_simplified/show_process/${packing_house_process_id}`
    );
  },
  fetchContainer(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/final_packing_list_simplified/assign_packages/${packing_house_process_id}/fetch_container/${container_id}`
    );
  },
  fetchUnassignedPackages(packing_house_process_id, container_id, weeks) {
    return RequesterV1.get(
      `packing_house/production/final_packing_list_simplified/assign_packages/${packing_house_process_id}/fetch_unassigned_packages/${container_id}/${weeks}`
    );
  },
  assignPackages(packing_house_process_id, container_id, packages) {
    return RequesterV1.post(
      `packing_house/production/final_packing_list_simplified/assign_packages/${packing_house_process_id}/assign_packages/${container_id}`,
      { packages }
    );
  },
};
